import { capitalize } from '@repo-level/core-front';
import { forwardRef, InputHTMLAttributes } from 'react';

import {
  InputStructure,
  InputStructureProps,
} from '../structures/InputStructure';

import {
  ScInput,
  ScInputIcon,
  ScInputInternalLabel,
  ScInputProps,
} from './styled';

export type InputBlockProps = InputHTMLAttributes<HTMLInputElement> &
  InputStructureProps & {
    icon?: string;
    internalLabel?: string;
  } & Omit<ScInputProps, 'error' | 'icon'>;

export const InputBlock = forwardRef<HTMLInputElement, InputBlockProps>(
  (
    {
      error,
      hideErrorMessage,
      prefix,
      disabled,
      icon,
      whiteWhenFilled,
      internalLabel,
      ...rest
    },
    ref
  ) => {
    return (
      <InputStructure
        error={error}
        hideErrorMessage={hideErrorMessage}
        disabled={disabled}
        whiteWhenFilled={whiteWhenFilled && !!rest.value}
        {...rest}
      >
        {icon && <ScInputIcon src={icon} alt="" />}
        {internalLabel && (
          <ScInputInternalLabel>{internalLabel}</ScInputInternalLabel>
        )}
        <ScInput
          {...rest}
          icon={icon != null}
          error={error != null}
          ref={ref}
          disabled={disabled}
          className={rest.value != null && rest.value !== '' ? 'filled' : ''}
          placeholder={rest.placeholder && capitalize(rest.placeholder)}
          whiteWhenFilled={whiteWhenFilled && !!rest.value}
        />
      </InputStructure>
    );
  }
);
